export const childAgeOptions = [
  { value: '0-12 months' },
  { value: '13-24 months' },
  { value: '2 years old' },
  { value: '3 years old' },
  { value: '4 years old' },
  { value: '5 years old' },
  { value: 'Kindergarten' },
  { value: '1st grade' },
  { value: '2nd grade' },
  { value: '3rd grade' },
  { value: '4th grade' },
  { value: '5th grade' },
  { value: '6th grade' },
  { value: 'Middle school aged' },
  { value: 'High school aged' },
  { value: 'College aged' },
];

export const centerTypeOptions = [
  { value: 'Public School' },
  { value: 'Private School' },
  { value: 'Charter School' },
  { value: 'Licensed Child-Care Center ' },
  { value: 'Large Capacity Licensed Child-Care Home / Family Child-Care' },
  { value: 'Small Capacity Licensed Child-Care Home / Family Child-Care' },
];

export const educationSettingOptions = [
  { value: 'Preschool, Childcare Center, Daycare' },
  { value: 'Family Childcare Home' },
  { value: 'Private Home or Individual Family (as a Nanny or Babysitter)' },
  { value: 'Before or Afterschool Program' },
  { value: 'K-12th grade (Elementary, Middle or High School)' },
  { value: 'Tutoring Center' },
  { value: 'Camp' },
];

export const roleTypeOptions = [
  { value: 'Full-time' },
  { value: 'Part-time' },
  { value: 'Seasonal' },
  { value: 'Substitute' },
];

export const approachOptions = [
  { value: 'Bank Street', label: 'Bank Street' },
  { value: 'Big Day for Pre-K, Texas Program', label: 'Big Day for Pre-K, Texas Program' },
  { value: 'Bilingual / Language Immersion', label: 'Bilingual / Language Immersion' },
  { value: 'Collaboration', label: 'Collaboration' },
  { value: 'Creative Curriculum', label: 'Creative Curriculum' },
  { value: 'DOE Exploration', label: 'DOE Exploration' },
  { value: 'Frog Street Pre-K Texas System', label: 'Frog Street Pre-K Texas System' },
  { value: 'HighScope', label: 'HighScope' },
  { value: 'Inclusion', label: 'Inclusion' },
  { value: 'Montessori', label: 'Montessori' },
  { value: 'Opening the World of Learning', label: 'Opening the World of Learning' },
  { value: 'Parent Cooperative', label: 'Parent Cooperative' },
  { value: 'Project-Based Learning (PBL)', label: 'Project-Based Learning (PBL)' },
  { value: 'Reggio Emilia', label: 'Reggio Emilia' },
  { value: 'Faith-based', label: 'Faith-based' },
  {
    value: 'Teaching Strategies System for Pre-K, Texas Edition',
    label: 'Teaching Strategies System for Pre-K, Texas Edition',
  },
  { value: 'Texas Comprehensive Pre-K', label: 'Texas Comprehensive Pre-K' },
  { value: 'Texas DLM Early Childhood Express', label: 'Texas DLM Early Childhood Express' },
  { value: 'Waldorf', label: 'Waldorf' },
];

export const languageOptions = [
  { value: 'Afrikaans', label: 'Afrikaans' },
  { value: 'Albanian', label: 'Albanian' },
  { value: 'American Sign Language (ASL)', label: 'American Sign Language (ASL)' },
  { value: 'Amharic', label: 'Amharic' },
  { value: 'Arabic', label: 'Arabic' },
  { value: 'Armenian', label: 'Armenian' },
  { value: 'Basque', label: 'Basque' },
  { value: 'Bengali', label: 'Bengali' },
  { value: 'Byelorussian', label: 'Byelorussian' },
  { value: 'Burmese', label: 'Burmese' },
  { value: 'Bulgarian', label: 'Bulgarian' },
  { value: 'Catalan', label: 'Catalan' },
  { value: 'Czech', label: 'Czech' },
  { value: 'Chinese (Cantonese)', label: 'Chinese (Cantonese)' },
  { value: 'Chinese (Mandarin)', label: 'Chinese (Mandarin)' },
  { value: 'Croatian', label: 'Croatian' },
  { value: 'Danish', label: 'Danish' },
  { value: 'Dari', label: 'Dari' },
  { value: 'Dzongkha', label: 'Dzongkha' },
  { value: 'Dutch', label: 'Dutch' },
  { value: 'Esperanto', label: 'Esperanto' },
  { value: 'Estonian', label: 'Estonian' },
  { value: 'Faroese', label: 'Faroese' },
  { value: 'Farsi', label: 'Farsi' },
  { value: 'Finnish', label: 'Finnish' },
  { value: 'French', label: 'French' },
  { value: 'Gaelic', label: 'Gaelic' },
  { value: 'Galician', label: 'Galician' },
  { value: 'German', label: 'German' },
  { value: 'Greek', label: 'Greek' },
  { value: 'Hebrew', label: 'Hebrew' },
  { value: 'Hindi', label: 'Hindi' },
  { value: 'Hungarian', label: 'Hungarian' },
  { value: 'Icelandic', label: 'Icelandic' },
  { value: 'Indonesian', label: 'Indonesian' },
  { value: 'Inuktitut (Eskimo)', label: 'Inuktitut (Eskimo)' },
  { value: 'Italian', label: 'Italian' },
  { value: 'Japanese', label: 'Japanese' },
  { value: 'Khmer', label: 'Khmer' },
  { value: 'Korean', label: 'Korean' },
  { value: 'Kurdish', label: 'Kurdish' },
  { value: 'Laotian', label: 'Laotian' },
  { value: 'Latvian', label: 'Latvian' },
  { value: 'Lappish', label: 'Lappish' },
  { value: 'Lithuanian', label: 'Lithuanian' },
  { value: 'Macedonian', label: 'Macedonian' },
  { value: 'Malay', label: 'Malay' },
  { value: 'Maltese', label: 'Maltese' },
  { value: 'Nepali', label: 'Nepali' },
  { value: 'Norwegian', label: 'Norwegian' },
  { value: 'Pashto', label: 'Pashto' },
  { value: 'Polish', label: 'Polish' },
  { value: 'Portuguese', label: 'Portuguese' },
  { value: 'Romanian', label: 'Romanian' },
  { value: 'Russian', label: 'Russian' },
  { value: 'Scots', label: 'Scots' },
  { value: 'Serbian', label: 'Serbian' },
  { value: 'Slovak', label: 'Slovak' },
  { value: 'Slovenian', label: 'Slovenian' },
  { value: 'Somali', label: 'Somali' },
  { value: 'Spanish', label: 'Spanish' },
  { value: 'Swedish', label: 'Swedish' },
  { value: 'Swahili', label: 'Swahili' },
  { value: 'Tagalog (Filipino)', label: 'Tagalog (Filipino)' },
  { value: 'Tajik', label: 'Tajik' },
  { value: 'Tamil', label: 'Tamil' },
  { value: 'Thai', label: 'Thai' },
  { value: 'Tibetan', label: 'Tibetan' },
  { value: 'Tigrinya', label: 'Tigrinya' },
  { value: 'Tongan', label: 'Tongan' },
  { value: 'Turkish', label: 'Turkish' },
  { value: 'Turkmen', label: 'Turkmen' },
  { value: 'Ukrainian', label: 'Ukrainian' },
  { value: 'Urdu', label: 'Urdu' },
  { value: 'Uzbek', label: 'Uzbek' },
  { value: 'Vietnamese', label: 'Vietnamese' },
  { value: 'Welsh', label: 'Welsh' },
];

export const jobTitles = [
  { value: 'Assistant Teacher' },
  { value: 'Assistant Preschool Teacher' },
  { value: 'ABA Therapist' },
  { value: 'Aide' },
  { value: 'Assistant Infant Teacher' },
  { value: 'Assistant Infant/Toddler Teacher' },
  { value: 'Assi`stant Pre-K Teacher' },
  { value: 'Assistant Toddler Teacher' },
  { value: 'Au Pair' },
  { value: 'Babysitter' },
  { value: 'Camp Counselor' },
  { value: 'Certified Assistant in a Large Family Child Care Program' },
  { value: 'Certified Assistant' },
  { value: "Children's Art Teacher" },
  { value: "Children's Dance Teacher" },
  { value: "Children's Music Teacher" },
  { value: 'Classroom Teacher' },
  { value: 'Direct Support Professional' },
  { value: 'Director' },
  { value: 'Early Childhood Director' },
  { value: 'Early Head Start Assistant Teacher' },
  { value: 'Early Head Start Teacher' },
  { value: 'Educational Director' },
  { value: 'Family Childcare Assistant' },
  { value: 'Family Childcare Owner' },
  { value: 'Family Childcare Worker' },
  { value: 'Head Preschool Teacher' },
  { value: 'Head Start Assistant Teacher' },
  { value: 'Head Start Teacher' },
  { value: 'Infant Teacher' },
  { value: 'Infant/Toddler Teacher' },
  { value: 'Instructional Leader' },
  { value: 'Kindergarten Teacher' },
  { value: 'Large Family Child Care Provider' },
  { value: 'Lead Classroom Teacher' },
  { value: 'Lead Preschool Teacher' },
  { value: 'Nanny' },
  { value: 'Operational Leader' },
  { value: 'Paraprofessional' },
  { value: 'Personal Care Assistant' },
  { value: 'Pre-K Teacher' },
  { value: 'Preschool Director' },
  { value: 'Preschool Floater Teacher' },
  { value: 'Preschool Teacher' },
  { value: 'Program Administrator' },
  { value: 'Program Manager' },
  { value: 'Site Coordinator' },
  { value: 'Special Education Teacher' },
  { value: 'Student Intern' },
  { value: 'Student Teacher' },
  { value: 'Substitute Assistant Preschool Teacher' },
  { value: 'Substitute Preschool Teacher' },
  { value: "Teacher's Aide" },
  { value: "Teacher's Assistant" },
  { value: 'Teacher' },
  { value: 'Toddler Teacher' },
  { value: 'Tutor' },
];
